
export default class ScreenReaderPlugin {
    private screenReaderToggleDesktop: HTMLDivElement;
    private screenReaderToggleMobile: HTMLDivElement;
    private desktopNav: HTMLDivElement;
    private mobileNav: HTMLDivElement;
    private speechControl: ScreenReaderControl;
    constructor() {
        this.desktopNav = document.querySelector(".navigation__desktop");
        this.mobileNav = document.querySelector(".navigation__mobile");
        this.screenReaderToggleDesktop = this.desktopNav.querySelector(".text-to-speech");
        this.screenReaderToggleMobile = this.mobileNav.querySelector(".text-to-speech span");

        this.speechControl = new ScreenReaderControl();

        this.InitScreenReader();
    }

    private InitScreenReader() {
        const ariaLabels: NodeListOf<HTMLDivElement> = document.querySelectorAll("[aria-label]");
        const mainElement = document.querySelector("main");
        const footerElement = document.querySelector("footer");
        let pageContent = "";
        if (!mainElement || !footerElement) {
            console.warn("No <main> or <footer> element found in the document.");
            return;
        }

        const mainContent = this.getAllTextForScreenReader(mainElement);
        const footerContent = this.getAllTextForScreenReader(footerElement);
        pageContent = mainContent + " " + footerContent;


        let screenReaderIsOn: string = sessionStorage.getItem("screenReaderIsOn");
        if (screenReaderIsOn == "true") {
            this.screenReaderToggleDesktop.classList.remove("fa-volume-off")
            this.screenReaderToggleMobile.classList.remove("fa-volume-off")
            this.screenReaderToggleDesktop.classList.add("fa-volume-up")
            this.screenReaderToggleMobile.classList.add("fa-volume-up")
            this.speechControl.speak(pageContent);
        }
        else {
            this.screenReaderToggleDesktop.classList.add("fa-volume-off")
            this.screenReaderToggleMobile.classList.add("fa-volume-off")
            this.screenReaderToggleDesktop.classList.remove("fa-volume-up")
            this.screenReaderToggleMobile.classList.remove("fa-volume-up")
            screenReaderIsOn = "false"
        }

        ariaLabels.forEach((ariaLabel: HTMLDivElement) => {
            ariaLabel.addEventListener("focus", () => {
                if (this.screenReaderToggleDesktop.classList.contains("fa-volume-up")) {
                    this.speechControl.speak(ariaLabel.getAttribute("aria-label"));
                }
            });
        });

        const toggleScreenReader = (activate: boolean) => {
            if (activate) {
                this.screenReaderToggleDesktop.classList.remove("fa-volume-off")
                this.screenReaderToggleMobile.classList.remove("fa-volume-off")
                this.screenReaderToggleDesktop.classList.add("fa-volume-up")
                this.screenReaderToggleMobile.classList.add("fa-volume-up")
                sessionStorage.setItem("screenReaderIsOn", "true");
                this.speechControl.speak("Text reader has been activated");
            } else {
                this.screenReaderToggleDesktop.classList.add("fa-volume-off")
                this.screenReaderToggleMobile.classList.add("fa-volume-off")
                this.screenReaderToggleDesktop.classList.remove("fa-volume-up")
                this.screenReaderToggleMobile.classList.remove("fa-volume-up")
                sessionStorage.setItem("screenReaderIsOn", "false");
                this.speechControl.stop();
                this.speechControl.speak("Text reader has been deactivated");
            }
        };

        const toggleOnClick = (e: Event) => {
            e.stopPropagation();
            e.preventDefault();
            const isActivated = this.screenReaderToggleDesktop.classList.contains("fa-volume-up");
            toggleScreenReader(!isActivated);
        };

        this.recursiveModalCheck();
        this.screenReaderToggleMobile.addEventListener("click", toggleOnClick);
        this.screenReaderToggleDesktop.addEventListener("click", toggleOnClick);
    }
    private recursiveModalCheck = () => {
        const isModalOpen = this.checkForModal();
        if (!isModalOpen) {
            setTimeout(() => {
                this.recursiveModalCheck();
            }, 1000);
        }
    };
    private checkForModal() {
        const screenReaderIsOn = sessionStorage.getItem("screenReaderIsOn");

        const modalElements = document.querySelectorAll(".modal.show, .event-calendar-popup-window.show");

        let spoken = false; 

        if (modalElements.length > 0 && screenReaderIsOn === "true") {
            modalElements.forEach((modalElement: Element) => {
                if (!spoken) {
                    const modalContent = this.getAllTextForScreenReader(modalElement as HTMLElement);
                    if (modalContent) {
                        this.speechControl.speak(modalContent);
                        spoken = true;
                    }
                    const closeButton = modalElement.querySelector("button");
                    closeButton.addEventListener("click", () => {
                        this.speechControl.stop();
                        this.recursiveModalCheck()
                    })
                }
            });
        }
        return spoken;
    }
    private getAllTextForScreenReader(element: any): string {

        if (element.offsetHeight === 0 || element.offsetWidth === 0) {
            return '';
        }

        let text = '';
        if (element.nodeType === Node.TEXT_NODE) {
            text += element.textContent + ' ';
        } else if (element.nodeType === Node.ELEMENT_NODE) {
            for (let i = 0; i < element.childNodes.length; i++) {
                text += this.getAllTextForScreenReader(element.childNodes[i]);
            }
        }
        return text;
    }
}

class ScreenReaderControl {
    private synthesis: SpeechSynthesis;
    private utterance: SpeechSynthesisUtterance;

    constructor() {
        this.synthesis = window.speechSynthesis;
        this.utterance = new SpeechSynthesisUtterance();
    }

    speak(text: string) {
        this.stop();

        this.utterance.text = text;
        this.synthesis.speak(this.utterance);
    }

    stop() {
        this.synthesis.cancel();
    }
}
